<div class="dialog_wrapper" style="display: contents">
    <ng-container #content></ng-container>
</div>
